import BaseOption from "%/dynamic-components/render-engine/classes/base-option";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";

// Visitor/compile twin of the DCE `scale` option. The live authoring control is
// the DCE ScaleControl; here the option only needs to exist so the compiled
// container carries the anchor and the appearance mixin can read it. "unset" = off.
export default class ScaleWidthAnchor extends BaseOption {
  static userInterfaceComponent = {
    label: "Scale",
    component: inspectorTools.SIMPLE_INPUT,
    props: {
      inputType: "number",
      append: "px",
    },
  };

  static defaultValue = "unset";

  static convertConfigValueToCompiledValue(configValue) {
    if (configValue === "unset" || configValue === "" || configValue === null || configValue === undefined) {
      return "unset";
    }
    const px = parseInt(configValue, 10);
    return Number.isFinite(px) && px > 0 ? px : "unset";
  }
}
